// hooks/useNotifications.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  setAnnouncementStatus,
  setChatStatus,
  setEventsStatus,
  setGnnStatus,
  setOnlineUsers,
} from '../../features/Auth/authSlice';
import { announcementApiSlice } from '../../features/Announcement/announcementApiSlice';
import { gnnApiSlice } from '../../features/Gnn/gnnApiSlice';
import { EventApiSlice } from '../../features/Events/eventsApiSlice';
import { userApiSlice } from '../../features/Users/userApiSlice';
import { chatApiSlice } from '../../features/Chats/chatApiSlice';

const useNotifications = (socket) => {
  const dispatch = useDispatch();

  useEffect(() => {
    socket.on('new-announcement', (announcement) => {
      dispatch(announcementApiSlice.util.invalidateTags([{ type: 'Announcement', id: 'LIST' }]));
      dispatch(setAnnouncementStatus(true));
    });

    socket.on('new-chats', (chats) => {
      dispatch(chatApiSlice.util.invalidateTags([{ type: 'Chat', id: 'LIST' }]));
      dispatch(setChatStatus(true));
    });

    socket.on('new-gnn', (gnn) => {
      dispatch(gnnApiSlice.util.invalidateTags([{ type: 'News', id: gnn._id }]));
      dispatch(setGnnStatus(true));
    });

    socket.on('new-count', (gnn) => {
      dispatch(gnnApiSlice.util.invalidateTags([{ type: 'News', id: gnn._id }]));
    });

    socket.on('new-events', (events) => {
      dispatch(EventApiSlice.util.invalidateTags([{ type: 'Events', id: 'LIST' }]));
      dispatch(setEventsStatus(true));
    });

    socket.on('user-permissions-update', ({ empCode }) => {
      dispatch(userApiSlice.util.invalidateTags([{ type: 'Permission', id: empCode }]));
    });
  }, [dispatch, socket]);
};

export default useNotifications;
